import ParentPageAside from './ParentPageAside/ParentPageAside';

const ParentPageDesktopView = () => {
  return (
    <section className="hidden laptop:flex justify-center gap-[clamp(1rem,3.3vw,3rem)]">
      <ParentPageAside />
    </section>
  );
};

export default ParentPageDesktopView;
